import React from 'react';
import { inject, observer } from 'mobx-react';
import compose from 'helpers/compose';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import ModalHeader from 'components/DialogHeader/DialogHeader';
import { UserStoreKC } from 'stores/userStoreKC';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      padding: theme.spacing(3),
    },
  }),
);

interface Props {
  userStore?: UserStoreKC;
  open: boolean;
  close: () => void;
  openNewAccount: () => void;
}

const NewAccountInstructionsDialog: React.FC<Props> = ({ userStore, open, close }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { loggedUser } = userStore!;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <ModalHeader onClose={close}>{t('newAccount_title_alt')}</ModalHeader>
      <DialogContent className={classes.content}>
        <Typography
          dangerouslySetInnerHTML={{
            __html: t(`intermediary_${(loggedUser?.realm || '').toUpperCase()}_newAccountInfo`, {
              interpolation: { escapeValue: false },
            }),
          }}
        />
      </DialogContent>
      <DialogActions>
        {loggedUser?.realm === 'bt' && (
          <Button variant="contained" color="primary" href={t(`intermediary_${(loggedUser?.realm || '').toUpperCase()}_newAccountLink`)}>
            {t(`intermediary_${(loggedUser?.realm || '').toUpperCase()}_newAccountOpen`)}
          </Button>
        )}
        <Button variant="contained" onClick={close}>
          {t('general_close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(inject('userStore'), observer)(NewAccountInstructionsDialog);
